var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28465",
    "data-name": "Group 28465",
    transform: "translate(11296 6615)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13563",
    "data-name": "Rectangle 13563",
    width: 32,
    height: 32,
    transform: "translate(-11296 -6615)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-11291 -6610)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8 8)",
    fill: "rgba(0,0,0,0)",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45438",
    "data-name": "Path 45438",
    d: "M17.727,13.727a1.5,1.5,0,0,0,.3,1.655l.055.055a1.819,1.819,0,1,1-2.573,2.573l-.055-.055a1.512,1.512,0,0,0-2.564,1.073v.155a1.818,1.818,0,0,1-3.636,0V19.1a1.5,1.5,0,0,0-.982-1.373,1.5,1.5,0,0,0-1.655.3l-.055.055a1.819,1.819,0,1,1-2.573-2.573l.055-.055a1.512,1.512,0,0,0-1.073-2.564H2.818a1.818,1.818,0,0,1,0-3.636H2.9a1.5,1.5,0,0,0,1.373-.982,1.5,1.5,0,0,0-.3-1.655l-.055-.055A1.819,1.819,0,1,1,6.491,3.991l.055.055a1.5,1.5,0,0,0,1.655.3h.073a1.5,1.5,0,0,0,.909-1.373V2.818a1.818,1.818,0,0,1,3.636,0V2.9a1.512,1.512,0,0,0,2.564,1.073l.055-.055a1.819,1.819,0,1,1,2.573,2.573l-.055.055a1.5,1.5,0,0,0-.3,1.655v.073a1.5,1.5,0,0,0,1.373.909h.155a1.818,1.818,0,0,1,0,3.636H19.1A1.5,1.5,0,0,0,17.727,13.727Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#8a8a8a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.5e3bd318.svg";
export { ForwardRef as ReactComponent };